import { render, staticRenderFns } from "./ShareCustomersToken.vue?vue&type=template&id=2fd79c4a"
import script from "./ShareCustomersToken.vue?vue&type=script&lang=js"
export * from "./ShareCustomersToken.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomersToken.vue?vue&type=style&index=0&id=2fd79c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports